import i18n from '@/utils/i18n';
import timezoneOptions from './timezones'

const fields =
  {
    event: {
      title: i18n.t('tievent.title'),
      items: [
        {
          name: "title",
          type: "text",
          required: true,
          label: i18n.t('tievent.form.title')
        },
        {
          name: "slug",
          type: "text",
          required: true,
          label: i18n.t('tievent.form.slug')
        },
        {
          name: "description",
          type: "textarea",
          required: false,
          label: i18n.t('tievent.form.description')
        },
        {
          name: "photo",
          type: "file",
          required: false,
          label: i18n.t('tievent.form.image')
        },
        // {
        //   name: "event_type",
        //   type: "select",
        //   required: false,
        //   allowEmpty: false,
        //   preselectFirst: true,
        //   options: [
        //     {
        //       name: "Virtual",
        //       value: "virtual"
        //     },
        //     {
        //       name: "Venue",
        //       value: "venue"
        //     }
        //   ],
        //   label: i18n.t('tievent.form.type'),
        // },
        {
          name: "is_virtual",
          type: "switch",
          label: i18n.t('tievent.form.type'),
          title: i18n.t('tievent.form.virtual'),
          titleFalse: i18n.t('tievent.form.venue')
        },
        {
          name: "location",
          type: "text",
          required: false,
          label: i18n.t('tievent.form.location_info')
        },
        {
          name: "timezone",
          type: "select",
          required: false,
          allowEmpty: false,
          preselectFirst: true,
          options: timezoneOptions,
          label: i18n.t('tievent.form.timezone'),
        },
        {
          name: "start_date",
          type: "date",
          main: false,
          "is-range": false,
          mode: 'dateTime',
          required: true,
          allowEmpty: false,
          label: i18n.t('tievent.form.event_start_date'),
          max: "end_date",
          modelConfig: {
            timeAdjust: null
          }
        },
        {
          name: "end_date",
          type: "date",
          main: false,
          "is-range": false,
          mode: 'dateTime',
          required: true,
          allowEmpty: false,
          label: i18n.t('tievent.form.event_end_date'),
          min: "start_date",
          modelConfig: {
            timeAdjust: null
          }
        },
        {
          name: "registration_page",
          type: "text",
          required: false,
          label: i18n.t('tievent.form.page')
        },
        {
          name: "url",
          type: "text",
          required: false,
          label: i18n.t('tievent.form.url')
        },
        {
          name: "contact_email",
          type: "text",
          required: false,
          label: i18n.t('tievent.form.email')
        },
        {
          name: "active",
          type: "switch",
          label: i18n.t('form.active'),
          title: i18n.t('global.yes'),
          titleFalse: i18n.t('global.no')
        }
      ]
    },
    tickets: {
      title: i18n.t('tievent.tickets'),
      items: [
        {
          name: 'id',
          type: "text",
          readOnly: true,
          label: i18n.t('form.id')
        },
        {
          name: "title",
          type: "text",
          required: true,
          label: i18n.t('form.title')
        },
        {
          name: "description",
          type: "textarea",
          required: false,
          label: i18n.t('form.description')
        },
        {
          name: "price",
          type: "number",
          required: false,
          min: 0,
          label: i18n.t('form.price'),
        },
        {
          name: "vat_percent",
          type: "number",
          required: false,
          min: 0,
          max: 100,
          maxLength: 3,
          label: i18n.t('form.vat_percent'), //is_applied_vat
        },
        {
          name: "is_applied_vat",
          type: "switch",
          label: i18n.t('form.apply_vat'),
          title: i18n.t('global.yes'),
          titleFalse: i18n.t('global.no')
        },
        {
          name: "quantity",
          type: "number",
          required: false,
          min: 0,
          label: i18n.t('tievent.form.quantity'),
          title: "Unlimited"
        },
        {
          name: "quantity-range",
          type: "range",
          main: false,
          label: i18n.t('tievent.form.quantity_range'),
          options: [
            {
              placeholder: i18n.t('form.from'),
              name: "min_quantity_order",
              type: "number"
            },
            {
              placeholder: i18n.t('form.to'),
              name: "max_quantity_order",
              type: "number"
            }
          ]
        },
        // {
        //   name: "percent",
        //   type: "text",
        //   required: false,
        //   min: 0,
        //   label: i18n.t('tievent.form.percent'),
        // },
        {
          name: "start_date",
          type: "date",
          main: false,
          mode: 'dateTime',
          isRange: false,
          label: i18n.t('tievent.form.ticket_sales_start'),
          max: "end_date",
          modelConfig: {
            timeAdjust: null
          }
        },
        {
          name: "end_date",
          type: "date",
          main: false,
          mode: 'dateTime',
          isRange: false,
          label: i18n.t('tievent.form.ticket_sales_end'),
          min: "start_date",
          modelConfig: {
            timeAdjust: null
          }
        },
        {
          name: "mailchimp_tags",
          type: "select",
          taggable: true,
          main: false,
          label: 'Mailchimp Tags',
          options: [],
          multiple: true,
          assembleValues: false
        },
        {
          name: "attach_subscription_id",
          type: "select",
          storeGetter: 'data/plans',
          storeAction: 'data/fetchPlans',
          groupValues: 'subscriptions',
          groupLabel: 'title',
          assembleValues: true,
          main: false,
          label: 'Assign Subscription',
          multiple: false,
          trackBy: 'id',
          labelKey: 'title',
        },
        {
          name: "plan_discounts",
          label: "Discounts",
          type: "repeater",
          assembleValues: false,
          fields: [
            {
              name: "plan_id",
              type: "select",
              storeGetter: 'data/plans',
              storeAction: 'data/fetchPlans',
              assembleValues: true,
              label: 'Plan',
              trackBy: 'id',
              labelKey: 'title',
              outputValue: 'id'
            },
            {
              name: "discount_type",
              type: "select",
              label: i18n.t('form.discount_type'),
              trackBy: 'value',
              assembleValues: true,
              options: [
                {
                  name: 'percent',
                  value: 'percent'
                },{
                  name: 'amount',
                  value: 'amount'
                }
              ],
              defaultValue: 'amount',
              multiple: false
            },
            {
              name: "discount",
              type: "discount",
              label: i18n.t('form.discount'),
              required: false,
              discount_type_field: 'discount_type'
            },
            {
              name: "active",
              type: "switch",
              label: i18n.t('form.status'),
            },
          ]
        },
        {
          name: "active",
          type: "switch",
          label: i18n.t('form.status'),
          title: i18n.t('form.active'),
          titleFalse: i18n.t('form.disabled')
        },
        {
          name: "is_public",
          type: "switch",
          label: i18n.t('form.public'),
          title: i18n.t('global.yes'),
          titleFalse: i18n.t('global.no')
        },

      ]
    }
  };

export default fields
